<template>
  <select
      name="dropdown"
      :id="id"
      :value="modelValue"
      @change="setChecked"
      class="dropdown"
      :style="{border: border ? '1px solid #d1d5db' : null}"
  >
    <option value="placeholder">-- {{ placeholder }} --</option>
    <option :value="item.value" :key="index" v-for="(item, index) in items">{{ item.name }}</option>
  </select>
</template>

<script>
export default{
  name:'DropdownVue',
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    placeholder: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    border: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: String,
      default: 'placeholder'
    }
  },
  emits: ['setChecked', 'update:modelValue'],
  methods: {
    setChecked(event){
      const value = event.target.value
      this.$emit('update:modelValue', value)
      this.$emit('setChecked', value)
    }
  }
}
</script>

<style scoped lang='scss'>
.dropdown{
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 12px 16px;
  background: #fff;
  color: #6b7280;
  font-size: 1.6rem;
  line-height: 1.4;
  transition: border-color .2s ease, box-shadow .2s ease;
  box-sizing: border-box;
  appearance: none;
  background-image:
      linear-gradient(45deg, transparent 50%, #9ca3af 50%),
      linear-gradient(135deg, #9ca3af 50%, transparent 50%);
  background-position:
      calc(100% - 18px) calc(50% - 3px),
      calc(100% - 12px) calc(50% - 3px);
  background-size: 6px 6px, 6px 6px;
  background-repeat: no-repeat;
  padding-right: 36px;
}
.dropdown:focus{
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 1px #10b981;
}
</style>